<div class="flex flex-column p-3">

  <h2>{{'model.kpi' | transloco}} {{kpiInfoForm.get('name').value}}</h2>

  <h4 class="mt-4 bold">{{'common.information' | transloco}}</h4>
  <div class="grid my-2">
    <div class="col-12 lg:col-6 xl:col-4">
      <p class="bold p-0 m-0">{{'attribute.description' | transloco}}</p>
      <p [class.font-italic]="!kpiInfoForm.get('description').value">
        {{kpiInfoForm.get('description').value || ("empty.description" | transloco)}}
      </p>
    </div>
    <div class="col-12 lg:col-6 xl:col-4">
      <p class="bold p-0 m-0">{{'model.tenant' | transloco}}</p>
      <p>{{kpiInfoForm.get('tenant')?.value?.name}}</p>
    </div>
    <div class="col-12 lg:col-6 xl:col-4">
      <p class="bold p-0 m-0">{{'model.organization' | transloco}}</p>
      <p [class.font-italic]="!kpiInfoForm.get('organization').value">{{kpiInfoForm.get('organization')?.value?.name ?? ('empty.organization' | transloco)}}</p>
    </div>
    <div class="col-12 lg:col-6 xl:col-4">
      <p class="bold p-0 m-0">{{'model.sensorType' | transloco}}</p>
      <p [class.font-italic]="!kpiInfoForm.get('measurementType').value">{{kpiInfoForm.get('measurementType')?.value?.sensor ?? ('empty.sensorType' | transloco)}}</p>
    </div>
  </div>

  <div *ngIf="mode === 'create'">

    <div *ngIf="enabledFilters.deviceMeasurementFilters || enabledFilters.assetMeasurementFilters || enabledFilters.kpiFilters" class="mt-6">
      <h4 class="mb-2 bold">{{'forms.sensorsByFilters' | transloco}}</h4>

      <div *ngIf="enabledFilters.deviceMeasurementFilters">
        <p class="bold p-0 mb-1 mt-3">{{'model.deviceMeasurements' | transloco}}</p>
        <ng-container [ngTemplateOutlet]="filteredDeviceMeasurementsTable"></ng-container>
      </div>
      <div *ngIf="enabledFilters.assetMeasurementFilters">
        <p class="bold p-0 mb-1 mt-3">{{'model.assetMeasurements' | transloco}}</p>
        <ng-container [ngTemplateOutlet]="filteredAssetMeasurementsTable"></ng-container>
      </div>
      <div *ngIf="enabledFilters.kpiFilters">
        <p class="bold p-0 mb-1 mt-3">{{'model.kpis' | transloco}}</p>
        <ng-container [ngTemplateOutlet]="filteredKpisTable"></ng-container>
      </div>
    </div>

    <div *ngIf="deviceMeasurements.length > 0 || assetMeasurements.length > 0 || kpis.length > 0" class="mt-6">
      <h4 class="mb-2 bold">{{'forms.additionalSensors' | transloco}}</h4>

      <div *ngIf="deviceMeasurements.length > 0">
        <p class="bold p-0 mb-1 mt-3">{{'model.deviceMeasurements' | transloco}}</p>
        <ng-container [ngTemplateOutlet]="deviceMeasurementsTable"></ng-container>
      </div>
      <div *ngIf="assetMeasurements.length > 0">
        <p class="bold p-0 mb-1 mt-3">{{'model.assetMeasurements' | transloco}}</p>
        <ng-container [ngTemplateOutlet]="assetMeasurementsTable"></ng-container>
      </div>
      <div *ngIf="kpis.length > 0">
        <p class="bold p-0 mb-1 mt-3">{{'model.kpis' | transloco}}</p>
        <ng-container [ngTemplateOutlet]="kpisTable"></ng-container>
      </div>
    </div>

  </div>

</div>

<!-- Table templates -->

<ng-template #filteredDeviceMeasurementsTable>
  <p-table
    [(first)]="filteredDeviceMeasurementsFirst"
    [(rows)]="filteredDeviceMeasurementsRows"
    [value]="filteredDeviceMeasurements"
    [totalRecords]="filteredTotalDeviceMeasurements"
    [lazy]="true"
    [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
    [paginator]="true"
    (onLazyLoad)="onFilteredDeviceMeasurementsPageChange($event)"
    styleClass="p-datatable-striped p-datatable-outline"
    sortField="name"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="w-18rem" pSortableColumn="device.serialNumber">
          {{'model.device' | transloco}}
          <p-sortIcon field="device.serialNumber"></p-sortIcon>
        </th>
        <th class="w-18rem" pSortableColumn="name">
          {{'model.sensor' | transloco}}
          <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th pSortableColumn="description">
          {{'attribute.description' | transloco}}
          <p-sortIcon field="description"></p-sortIcon>
        </th>
        <th pSortableColumn="measurementType.sensor">
          {{'model.sensorType' | transloco}}
          <p-sortIcon field="measurementType.sensor"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-measurement>
      <tr *ngIf="!filteredLoadingDeviceMeasurements">
        <td>
          <span class="p-column-title bold">{{'model.device' | transloco}}</span>
          {{measurement.device.serialNumber}}
        </td>
        <td>
          <span class="p-column-title bold">{{'model.sensor' | transloco}}</span>
          <p class="text-right md:text-left" style="word-break: break-all;">{{measurement.name}}</p>
        </td>
        <td>
          <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
          {{measurement.description}}
        </td>
        <td>
          <span class="p-column-title bold">{{'model.sensorType' | transloco}}</span>
          {{measurement.measurementType?.sensor ?? ''}}
        </td>
      </tr>
      <tr *ngIf="filteredLoadingDeviceMeasurements" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="summary">
      <div class="flex align-items-center justify-content-between" *ngIf="filteredTotalDeviceMeasurements == 0">
        {{'pagination.empty' | transloco}}
      </div>
      <div class="flex align-items-center justify-content-between" *ngIf="filteredTotalDeviceMeasurements > 0">
        {{'pagination.showing' | transloco}} {{filteredDeviceMeasurementsFirst + 1}}
        {{'pagination.to' | transloco}} {{
        (filteredDeviceMeasurementsFirst + filteredDeviceMeasurementsRows) >= filteredTotalDeviceMeasurements ?
          (filteredTotalDeviceMeasurements) :
          (filteredDeviceMeasurementsFirst + filteredDeviceMeasurementsRows)
        }}
        {{'pagination.of' | transloco}} {{filteredTotalDeviceMeasurements}}
        {{(filteredTotalDeviceMeasurements > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
      </div>
    </ng-template>
  </p-table>
</ng-template>

<ng-template #filteredAssetMeasurementsTable>
  <p-table
    [(first)]="filteredAssetMeasurementsFirst"
    [(rows)]="filteredAssetMeasurementsRows"
    [value]="filteredAssetMeasurements"
    [totalRecords]="filteredTotalAssetMeasurements"
    [lazy]="true"
    [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
    [paginator]="true"
    (onLazyLoad)="onFilteredAssetMeasurementsPageChange($event)"
    styleClass="p-datatable-striped"
    sortField="name"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="w-18rem" pSortableColumn="asset.alias">
          {{'model.asset' | transloco}}
          <p-sortIcon field="asset.alias"></p-sortIcon>
        </th>
        <th class="w-18rem" pSortableColumn="name">
          {{'model.sensor' | transloco}}
          <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th pSortableColumn="description">
          {{'attribute.description' | transloco}}
          <p-sortIcon field="description"></p-sortIcon>
        </th>
        <th pSortableColumn="measurementType.sensor">
          {{'model.sensorType' | transloco}}
          <p-sortIcon field="measurementType.sensor"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-measurement>
      <tr *ngIf="!filteredLoadingAssetMeasurements">
        <td>
          <span class="p-column-title bold">{{'model.asset' | transloco}}</span>
          {{measurement.asset.alias}}
        </td>
        <td>
          <span class="p-column-title bold">{{'model.sensor' | transloco}}</span>
          <p class="text-right md:text-left" style="word-break: break-all;">{{measurement.name}}</p>
        </td>
        <td>
          <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
          {{measurement.description}}
        </td>
        <td>
          <span class="p-column-title bold">{{'model.sensorType' | transloco}}</span>
          {{measurement.measurementType?.sensor ?? ''}}
        </td>
      </tr>
      <tr *ngIf="filteredLoadingAssetMeasurements" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="summary">
      <div class="flex align-items-center justify-content-between" *ngIf="filteredTotalAssetMeasurements == 0">
        {{'pagination.empty' | transloco}}
      </div>
      <div class="flex align-items-center justify-content-between" *ngIf="filteredTotalAssetMeasurements > 0">
        {{'pagination.showing' | transloco}} {{filteredAssetMeasurementsFirst + 1}}
        {{'pagination.to' | transloco}} {{
        (filteredAssetMeasurementsFirst + filteredAssetMeasurementsRows) >= filteredTotalAssetMeasurements ?
          (filteredTotalAssetMeasurements) :
          (filteredAssetMeasurementsFirst + filteredAssetMeasurementsRows)
        }}
        {{'pagination.of' | transloco}} {{filteredTotalAssetMeasurements}}
        {{(filteredTotalAssetMeasurements > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
      </div>
    </ng-template>
  </p-table>
</ng-template>

<ng-template #filteredKpisTable>
  <p-table
    [(first)]="filteredKpisFirst"
    [(rows)]="filteredKpisRows"
    [value]="filteredKpis"
    [totalRecords]="filteredTotalKpis"
    [lazy]="true"
    [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
    [paginator]="true"
    (onLazyLoad)="onFilteredKpisPageChange($event)"
    styleClass="p-datatable-striped"
    sortField="name"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name">
          {{'attribute.name' | transloco}}
          <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th pSortableColumn="description">
          {{'attribute.description' | transloco}}
          <p-sortIcon field="description"></p-sortIcon>
        </th>
        <th pSortableColumn="timePeriod">
          {{'attribute.timePeriod' | transloco}}
          <p-sortIcon field="timePeriod"></p-sortIcon>
        </th>
        <th pSortableColumn="operation">
          {{'attribute.operation' | transloco}}
          <p-sortIcon field="operation"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-kpi>
      <tr *ngIf="!filteredLoadingKpis" class="fadein">
        <td>
          <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
          <p class="text-right md:text-left">{{kpi.name}}</p>
        </td>
        <td>
          <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
          <p class="text-right md:text-left">{{kpi.description}}</p>
        </td>
        <td>
          <span class="p-column-title bold">{{'attribute.timePeriod' | transloco}}</span>
          <p class="text-right md:text-left">{{kpi.timePeriod}}</p>
        </td>
        <td>
          <span class="p-column-title bold">{{'attribute.operation' | transloco}}</span>
          <p class="text-right md:text-left">{{kpi.operation}}</p>
        </td>
      </tr>
      <tr *ngIf="filteredLoadingKpis" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="summary">
      <div class="flex align-items-center justify-content-between" *ngIf="filteredTotalKpis == 0">
        {{'pagination.empty' | transloco}}
      </div>
      <div class="flex align-items-center justify-content-between" *ngIf="filteredTotalKpis > 0">
        {{'pagination.showing' | transloco}} {{filteredKpisFirst + 1}}
        {{'pagination.to' | transloco}} {{
        (filteredKpisFirst + filteredKpisRows) >= filteredTotalKpis ?
          (filteredTotalKpis) :
          (filteredKpisFirst + filteredKpisRows)
        }}
        {{'pagination.of' | transloco}} {{filteredTotalKpis}}
        {{(filteredTotalKpis > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
      </div>
    </ng-template>
  </p-table>
</ng-template>

<ng-template #deviceMeasurementsTable>
  <p-table
    [(first)]="deviceMeasurementsFirst"
    [(rows)]="deviceMeasurementsRows"
    [value]="deviceMeasurements"
    [totalRecords]="deviceMeasurements.length"
    [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
    [paginator]="true"
    styleClass="p-datatable-striped p-datatable-outline"
    sortField="name"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="w-18rem" pSortableColumn="device.serialNumber">
          {{'model.device' | transloco}}
          <p-sortIcon field="device.serialNumber"></p-sortIcon>
        </th>
        <th class="w-18rem" pSortableColumn="name">
          {{'model.sensor' | transloco}}
          <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th pSortableColumn="description">
          {{'attribute.description' | transloco}}
          <p-sortIcon field="description"></p-sortIcon>
        </th>
        <th pSortableColumn="measurementType.sensor">
          {{'model.sensorType' | transloco}}
          <p-sortIcon field="measurementType.sensor"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-measurement>
      <tr>
        <td>
          <span class="p-column-title bold">{{'model.device' | transloco}}</span>
          {{measurement.device.serialNumber}}
        </td>
        <td>
          <span class="p-column-title bold">{{'model.sensor' | transloco}}</span>
          <p class="text-right md:text-left" style="word-break: break-all;">{{measurement.name}}</p>
        </td>
        <td>
          <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
          {{measurement.description}}
        </td>
        <td>
          <span class="p-column-title bold">{{'model.sensorType' | transloco}}</span>
          {{measurement.measurementType?.sensor ?? ''}}
        </td>
      </tr>
    </ng-template>
  </p-table>
  <ng-template pTemplate="summary">
    <div class="flex align-items-center justify-content-between" *ngIf="deviceMeasurements.length == 0">
      {{'pagination.empty' | transloco}}
    </div>
    <div class="flex align-items-center justify-content-between" *ngIf="deviceMeasurements.length > 0">
      {{'pagination.showing' | transloco}} {{deviceMeasurementsFirst + 1}}
      {{'pagination.to' | transloco}} {{
      (deviceMeasurementsFirst + deviceMeasurementsRows) >= deviceMeasurements.length ?
        (deviceMeasurements.length) :
        (deviceMeasurementsFirst + deviceMeasurementsRows)
      }}
      {{'pagination.of' | transloco}} {{deviceMeasurements.length}}
      {{(deviceMeasurements.length > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
    </div>
  </ng-template>
</ng-template>

<ng-template #assetMeasurementsTable>
  <p-table
    [(first)]="assetMeasurementsFirst"
    [(rows)]="assetMeasurementsRows"
    [value]="assetMeasurements"
    [totalRecords]="assetMeasurements.length"
    [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
    [paginator]="true"
    styleClass="p-datatable-striped p-datatable-outline"
    sortField="name"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="w-18rem" pSortableColumn="asset.alias">
          {{'model.asset' | transloco}}
          <p-sortIcon field="asset.alias"></p-sortIcon>
        </th>
        <th class="w-18rem" pSortableColumn="name">
          {{'model.sensor' | transloco}}
          <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th pSortableColumn="description">
          {{'attribute.description' | transloco}}
          <p-sortIcon field="description"></p-sortIcon>
        </th>
        <th pSortableColumn="measurementType.sensor">
          {{'model.sensorType' | transloco}}
          <p-sortIcon field="measurementType.sensor"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-measurement>
      <tr>
        <td>
          <span class="p-column-title bold">{{'model.asset' | transloco}}</span>
          {{measurement.asset.alias}}
        </td>
        <td>
          <span class="p-column-title bold">{{'model.sensor' | transloco}}</span>
          <p class="text-right md:text-left" style="word-break: break-all;">{{measurement.name}}</p>
        </td>
        <td>
          <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
          {{measurement.description}}
        </td>
        <td>
          <span class="p-column-title bold">{{'model.sensorType' | transloco}}</span>
          {{measurement.measurementType?.sensor ?? ''}}
        </td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>

<ng-template #kpisTable>
  <p-table
    [(first)]="kpisFirst"
    [(rows)]="kpisRows"
    [value]="kpis"
    [totalRecords]="kpis.length"
    [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
    [paginator]="true"
    styleClass="p-datatable-striped p-datatable-outline"
    sortField="name"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name">
          {{'attribute.name' | transloco}}
          <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th pSortableColumn="description">
          {{'attribute.description' | transloco}}
          <p-sortIcon field="description"></p-sortIcon>
        </th>
        <th pSortableColumn="organization.name" *ngIf="'ROLE_ADMIN' | userHasRole: false">
          {{'model.organization' | transloco}}
          <p-sortIcon field="organization.name"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-kpiRow>
      <tr>
        <td>
          <span class="p-column-title bold">{{'attribute.alias' | transloco}}</span>
          <p class="text-right md:text-left">{{kpiRow.name}}</p>
        </td>
        <td>
          <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
          <p class="text-right md:text-left">{{kpiRow.description}}</p>
        </td>
        <td *ngIf="'ROLE_ADMIN' | userHasRole: false">
          <span class="p-column-title bold">{{'model.organization' | transloco}}</span>
          <p class="text-right md:text-left">{{kpiRow.organization?.name}}</p>
        </td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>
